import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Pages Calendar
import Calendar from "../pages/Calendar/index"

//Email
import EmailInbox from "../pages/Email/email-inbox"
import EmailRead from "../pages/Email/email-read"
import EmailCompose from "../pages/Email/email-compose"



//course Registrations
import AddCourseRegistration from "pages/CourseRegistrations/AddCourseRegistration"
import CourseRegistrationsList from "pages/CourseRegistrations/CourseRegistrationsList"
import EditCourseRegistration from "pages/CourseRegistrations/EditCourseRegistrations"

//course Discounts
import CourseDiscountsList from "pages/CourseDiscounts/CourseDiscountsList"
import AddCourseDiscount from "pages/CourseDiscounts/AddCourseDiscount"
import EditCourseDiscount from "pages/CourseDiscounts/EditCourseDiscount"

//course Program Names
import AddCourseProgramName from "pages/CourseProgramNames/AddCourseProgramName"
import CourseProgramNamesList from "pages/CourseProgramNames/CourseProgramNamesList"
import EditCourseProgramName from "pages/CourseProgramNames/EditCourseProgramNames"


// Certifications
import Certifications from "../pages/Certifications/AddCertificationRegistrations"
import CertificationsRegistrationList from "../pages/Certifications/CertificationsRegistrationList"
import EditCertificateRegistration from "pages/Certifications/EditCertificateRegistrations"

// Refunds
import AddCourseRefunds from '../pages/CourseRefunds/AddCourseRefunds';
import CourseRefundsList from "pages/CourseRefunds/CourseRefundsList";
import EditCourseRefundsList from "pages/CourseRefunds/EditCourseRefunds";
import RefundApprovelist from "pages/CourseRefunds/GetCourseRefunds";
import RefundReceipt from "pages/CourseRefunds/RefundReceipt";
import RefundReceiptByRollNo from "pages/CourseRefunds/RefundReceiptByRollNo";


//course Payments
import CourseCards from "pages/CoursePayments/CourseCards";
import AddCoursePayment from "pages/CoursePayments/StudentPaymentCard"
import BulkUploadForPaymentStatus from "pages/CoursePayments/PaymentStatusBulkUpload";
import PaymentReceipt from "pages/CoursePayments/paymentReceipt";

//zero payments
import ZeroCoursePayments from "pages/ZeroCoursePayments/ZeroCourseCards"
import AddZeroCoursePayment from "pages/ZeroCoursePayments/ZeroStudentPaymentCard"


//student Registration
import AddStudentRegistration from "pages/StudentRegistrations/AddStudentRegistration"
import AddStudentRegistrationBulk from "pages/StudentRegistrations/AddStudentRegistrationBulk"

import StudentRegistrationsList from "pages/StudentRegistrations/StudentRegistrationsList"
import StudentRegistrationsCourseWiseList from "pages/StudentRegistrations/StudentRegistrationsCourseWiseList"
import UpdatePaymentStatusEligibility from "pages/StudentRegistrations/UpdatePaymentStatusEligibility"
import SwapStudentCourseRegistration from "pages/StudentRegistrations/SwapStudentCourseRegistration"
import SwapStudentCourseRegistrationAfterPaid from "pages/StudentRegistrations/SwapStudentCourseRegistrationAfterPaid"

//drop students
import DropStudentRegistrationBulk from "pages/StudentRegistrations/DropStudentRegistrationBulk"


//Tech panel
import TechPanelPayments from "pages/CourseTechPanel/TechPanelPayments";
import PaymentAnalytics from "pages/CourseTechPanel/PaymentAnalytics";
import PaymentAnalyticsDashboard from "pages/CourseTechPanel/PaymentAnalyticsDashboard";
import CodeForgePaymentAnalytics from "pages/CourseTechPanel/CodeForgePaymentAnalytics";

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import SendOtp from "../pages/Authentication/SendOtp"
import VerifyOtp from "../pages/Authentication/VerifyOtp"

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Register1 from "../pages/AuthenticationInner/Register"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import AdminDashboard from "../pages/Dashboard/SuperAdminDashbaord"
import AdminDashboradStats from "../pages/Dashboard/Stats"
import MonthlyWisePaymentsStatistics from "pages/Dashboard/MonthlyWisePaymentsStatistics"
import CourseWiseSeatsStatistics from "pages/Dashboard/CourseWiseSeatsStatistics.js"

//Charts
import ChartsAppex from "../pages/Charts/charts-appex";
import ChartsJs from "../pages/Charts/charts-chartjs";
import ChartsKnob from "../pages/Charts/charts-knob";
import ChartsC3 from "../pages/Charts/charts-c3";
import ChartsSparkLine from "../pages/Charts/charts-sparkline";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle"
import MapsVector from "../pages/Maps/MapsVector"

//Icons
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign"
import Iconion from "../pages/Icons/Iconion"
import IconFontawesome from "../pages/Icons/IconFontawesome"
import IconThemify from "../pages/Icons/IconThemify"
import IconDripicons from "../pages/Icons/IconDripicons"
import IconTypicons from "../pages/Icons/IconTypicons"

//Tables
import BasicTables from "../pages/Tables/BasicTables"
import DatatableTables from "../pages/Tables/DatatableTables"
import ResponsiveTables from "../pages/Tables/ResponsiveTables"
import EditableTables from "../pages/Tables/EditableTables"

// Forms
import FormElements from "../pages/Forms/FormElements"
import FormAdvanced from "../pages/Forms/FormAdvanced"
import FormEditors from "../pages/Forms/FormEditors"
import FormValidations from "../pages/Forms/FormValidations"
import FormUpload from "../pages/Forms/FormUpload"
import FormXeditable from "../pages/Forms/FormXeditable"

//Ui
import UiAlert from "../pages/Ui/UiAlert"
import UiButtons from "../pages/Ui/UiButtons"
import UiBadge from "../pages/Ui/UiBadge"
import UiCards from "../pages/Ui/UiCards"
import UiCarousel from "../pages/Ui/UiCarousel"
import UiDropdown from "../pages/Ui/UiDropdown"
import UiGrid from "../pages/Ui/UiGrid"
import UiImages from "../pages/Ui/UiImages"
import UiLightbox from "../pages/Ui/UiLightbox"
import UiModal from "../pages/Ui/UiModal"
import UiPagination from "../pages/Ui/UiPagination"
import UiPopoverTooltips from "../pages/Ui/UiPopoverTooltips"
import UiProgressbar from "../pages/Ui/UiProgressbar"
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions"
import UiTypography from "../pages/Ui/UiTypography"
import UiVideo from "../pages/Ui/UiVideo"
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout"
import UiRangeSlider from "../pages/Ui/UiRangeSlider"

//Extra Pages
import PagesTimeline from "../pages/Extra Pages/pages-timeline";
import PagesInvoice from "../pages/Extra Pages/pages-invoice";
import PagesDirectory from "../pages/Extra Pages/pages-directory";
import PagesBlank from "../pages/Extra Pages/pages-blank";
import Pages404 from "../pages/Extra Pages/pages-404";
import Pages500 from "../pages/Extra Pages/pages-500";
import UiUtilities from "pages/Ui/UiUtilities"
import UiColors from "pages/Ui/UiColors"
import UiOffcanvas from "pages/Ui/UiOffcanvas"
import Chat from "pages/Chat/Chat";
import Kanban from "pages/Kanban"
import StudentPaymentCard from "pages/CoursePayments/StudentPaymentCard"

const userRoutes = [
  { path: "/admin-dashboard", component: <AdminDashboard /> },
  { path: "/admin-stats", component: <AdminDashboradStats /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/payment-statistics", component: <MonthlyWisePaymentsStatistics /> },
  { path: "/course-wise-seats-statistics", component: <CourseWiseSeatsStatistics /> },

  // //calendar
  { path: "/calendar", component: <Calendar /> },

  { path: "/chat", component: <Chat /> },
  { path: "/kanbanboard", component: <Kanban /> },

  // // //profile
  { path: "/profile", component: <UserProfile /> },

  // //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read", component: <EmailRead /> },
  { path: "/email-compose", component: <EmailCompose /> },




  // Course Registrations
  { path: "/add-course-registration", component: <AddCourseRegistration /> },
  { path: "/edit-course-registration/:id", component: <EditCourseRegistration /> },
  { path: "/course-registrations-list", component: <CourseRegistrationsList /> },

  //course Discounts
  { path: "/course-discounts-list", component: <CourseDiscountsList /> },
  { path: "/add-course-discount", component: <AddCourseDiscount /> },
  { path: "/edit-course-discount/:id/:term_name", component: <EditCourseDiscount /> },

  //course ProgramNames
  { path: "/add-course-program-name", component: <AddCourseProgramName /> },
  { path: "/course-program-names-list", component: <CourseProgramNamesList /> },
  { path: "/edit-course-program-name/:id", component: <EditCourseProgramName /> },

  // //Certifications
  { path: "/add-certifications", component: <Certifications /> },
  { path: "/certifications-registration-list", component: <CertificationsRegistrationList /> },
  { path: "/edit-certification-registration/:id", component: <EditCertificateRegistration /> },

  // //Refunds
  { path: "/add-course-refunds", component: <AddCourseRefunds /> },
  { path: "/course-refunds-list", component: <CourseRefundsList /> },
  { path: "/edit-course-refunds/:id", component: <EditCourseRefundsList /> },
  { path: "/refund-approval-list", component: <RefundApprovelist /> },
  { path: "/refund-receipt", component: <RefundReceipt /> },
  { path: "/refund-receipt-by-roll-no", component: <RefundReceiptByRollNo /> },


  //course Payments
  { path: "/course-payments", component: <CourseCards /> },
  { path: "/add-course-payment/:course_id/:technology_id", component: <AddCoursePayment /> },
  { path: "/bulk-upload-payment-status", component: <BulkUploadForPaymentStatus /> },
  { path: "/payment-receipt", component: <PaymentReceipt /> },

  //zero course payments
  { path: "/zero-course-payments", component: <ZeroCoursePayments /> },
  { path: "/add-zero-course-payment/:course_id/:technology_id", component: <AddZeroCoursePayment /> },


  //student Registrations
  { path: "/add-student-registration", component: <AddStudentRegistration /> },
  { path: "/add-student-registration-bulk", component: <AddStudentRegistrationBulk /> },
  { path: "/Student-registrations-list", component: <StudentRegistrationsList /> },
  { path: "/Student-registrations-course-wise-list", component: <StudentRegistrationsCourseWiseList /> },
  { path: '/update-payment-status-eligibility/:id', component: <UpdatePaymentStatusEligibility /> },
  { path: "/swap-student-course", component: <SwapStudentCourseRegistration /> },
    { path: "/swap-student-course-after-paid", component: <SwapStudentCourseRegistrationAfterPaid /> },
  { path: "/drop-student-registration-bulk", component: <DropStudentRegistrationBulk /> },

  //Tech Panel
  { path: "/tech-panel-payments", component: <TechPanelPayments /> },
  { path: "/payment-analytics" , component: <PaymentAnalytics/>},
  { path: "/payment-analytics-dashboard" , component: <PaymentAnalyticsDashboard/>},
  { path: "/codeforge-payment-analytics", component: <CodeForgePaymentAnalytics /> },
  // //Charts
  { path: "/apex-charts", component: <ChartsAppex /> },
  { path: "/charts-chartjs", component: <ChartsJs /> },
  { path: "/charts-knob", component: <ChartsKnob /> },
  { path: "/charts-c3", component: <ChartsC3 /> },
  { path: "/sparkline-charts", component: <ChartsSparkLine /> },

  // // Icons
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-ion", component: <Iconion /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },
  { path: "/icons-themify", component: <IconThemify /> },
  { path: "/icons-dripicons", component: <IconDripicons /> },
  { path: "/icons-typicons", component: <IconTypicons /> },

  // // Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-datatable", component: <DatatableTables /> },
  { path: "/tables-responsive", component: <ResponsiveTables /> },
  { path: "/tables-editable", component: <EditableTables /> },

  // // Maps
  { path: "/maps-google", component: <MapsGoogle /> },
  { path: "/maps-vector", component: <MapsVector /> },

  // // Forms
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editors", component: <FormEditors /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-validation", component: <FormValidations /> },
  { path: "/form-xeditable", component: <FormXeditable /> },

  // // Ui
  { path: "/ui-alerts", component: <UiAlert /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-badge", component: <UiBadge /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModal /> },
  { path: "/ui-pagination", component: <UiPagination /> },
  { path: "/ui-popover-tooltip", component: <UiPopoverTooltips /> },
  { path: "/ui-progressbars", component: <UiProgressbar /> },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  { path: "/ui-utilities", component: <UiUtilities /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },

  // //Extra Pages
  { path: "/pages-timeline", component: <PagesTimeline /> },
  { path: "/pages-invoice", component: <PagesInvoice /> },
  { path: "/pages-directory", component: <PagesDirectory /> },
  { path: "/pages-blank", component: <PagesBlank /> },

  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/send-otp", component: <SendOtp /> },
  { path: "/verify-otp", component: <VerifyOtp /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
]

export { userRoutes, authRoutes }
